module.exports = __webpack_public_path__ + "media/images/new_landing/hp/tile-3-328c58ea134a7b7f2bbcb0f0f760be42.jpg";